const formatMarkdownText = (text?: string): string | undefined => {
  return text ? text.replace(/\\n/g, "\n") : text;
};

export default formatMarkdownText;
